<template>
  <div>
    <div v-if="!isMobile" class="oyunBarBackground h-[84px] flex flex-row justify-center my-9">
      <div class="w-full max-w-[1100px] flex items-center justify-between gap-x-4">
        <OImage loading="lazy" src="/images/game/emojile-logov1.png" style="width: 188px; height: 65px" />
        <OImage loading="lazy" src="/images/game/words.png" alt="" />
        <div class="flex">
          <OImage loading="lazy" src="/images/game/yildirim.png" class="emojiBackground p-2" />
          <span class="text-[#B2C0FF] font-normal text-lg self-center mx-2">+</span>
          <OImage loading="lazy" src="/images/game/tac.png" class="emojiBackground p-2" />
        </div>
        <OButton color-scheme="green" href="/emojile" class="w-[320px] h-[40px] u-center" @click="push()">
          <span>{{ $t('game.play-now') }}</span>
        </OButton>
      </div>
    </div>
    <div v-else class="oyunBarBackground h-[250px] flex flex-col my-9">
      <div class="relative flex flex-col justify-center items-center h-[250px]">
        <div class="absolute inset-0 opacity-10 mask overflow-hidden">
          <img src="~/static/images/game/emohis.png" />
        </div>
        <div class="absolute flex flex-col items-center">
          <div class="border-2 text-white text-xs font-bold py-0.5 px-2 rounded">{{ $t('game.most-played') }}</div>
          <div class="flex flex-row self-stretch items-center mt-4">
            <OImage loading="lazy" class="w-[188px] h-[65px]" src="/images/game/emojile-logov1.png" />
            <div class="flex ml-5">
              <OImage loading="lazy" src="/images/game/yildirim.png" class="emojiBackground p-2" />
              <span class="text-[#B2C0FF] font-normal text-lg self-center mx-2">+</span>
              <OImage loading="lazy" src="/images/game/tac.png" class="emojiBackground p-2" />
            </div>
          </div>
          <OButton color-scheme="green" href="/emojile" class="mt-4 w-full h-[40px] mx-8 u-center" @click="push()">
            <span>{{ $t('game.play-now') }}</span>
          </OButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { OButton, OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton, OImage },
  setup() {
    const { isMobile } = useDevice();
    const push = () => {
      window.dataLayer.push({
        event: 'game_interactions',
        event_action: 'game_click',
        event_label: 'Oyun - Küçük Bant', // Tüm Oyunlar ya da En Sevilenler olarak değişebilir. Emojile için bu değer "Oyun - Büyük Bant" ya da "Oyun - Küçük Bant" olarak değişir.
        game_name: 'Emojile', // Emojile de bu oyunlar arasındadır.
      });
    };
    return { isMobile, push };
  },
});
</script>

<style scoped lang="scss">
.oyunBarBackground {
  background: radial-gradient(50% 50% at 50% 50%, #22367b 0%, #030c51 100%), #d9d9d9;
}

.emojiBackground {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.3);
  border: 0.727273px solid rgba(255, 255, 255, 0.35);
  box-shadow: 0px 0px 8.72727px rgba(0, 0, 0, 0.05);
  border-radius: 4.36364px;
}
.mask img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-mask-image: linear-gradient(to right, transparent, black);
  mask-image: linear-gradient(to right, transparent, black);
}
</style>
